import { css } from 'styled-components'

import { Theme as DesignSystemTheme } from '@icontainers/design-system/dist/theme'

import { FONTS } from './fonts'
import { Typo } from './ThemeType'

const typo = Object.freeze(
    Object.keys(FONTS).reduce((acc: Typo, key: string) => {
        acc[key] = css`
            font-size: ${FONTS[key].fontSize};
            font-family: ${FONTS[key].fontFamily};
            line-height: ${FONTS[key].lineHeight};
        `

        return acc
    }, {})
)

export const IcontainersTheme = {
    ...DesignSystemTheme,
    typo,
}

export const Boxit4meTheme = {
    ...DesignSystemTheme,
    typo,
}
